import { render } from "./EventsCalendar.vue?vue&type=template&id=253f266c&scoped=true"
import script from "./EventsCalendar.vue?vue&type=script&lang=js"
export * from "./EventsCalendar.vue?vue&type=script&lang=js"

import "./EventsCalendar.vue?vue&type=style&index=0&id=253f266c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-253f266c"]])

export default __exports__